import { render, staticRenderFns } from "./ViewAwards.vue?vue&type=template&id=4b7e4406&scoped=true"
import script from "./ViewAwards.vue?vue&type=script&lang=js"
export * from "./ViewAwards.vue?vue&type=script&lang=js"
import style0 from "./ViewAwards.vue?vue&type=style&index=0&id=4b7e4406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e4406",
  null
  
)

export default component.exports